/**
 * 
 * key
 * 
 */


const key = 'bGVhZF9zZXJ2aWNl'

export default key 